import Link from '../../link/link';
import React from 'react';
import { DatoCmsLink, DatoCmsPageListItem } from '../../../schema/datocms/blocks';
import { Alignments } from '../../../schema/enum/alignments';
import { getTextAlignmentClass } from '../../../utilities/text-alignment';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import ApiImageComponent from '../api-image/api-image-component';

const PageListItemComponent = ({ title, titleAlignment, subtitle, subtitleAlignment, imageAlignment, showImageAsLink, showTitleAsLink, links, apiImage }: DatoCmsPageListItem): React.ReactElement => {
    const isCenterAligned: boolean = imageAlignment === Alignments.CENTER;
    const isRightAligned: boolean = imageAlignment === Alignments.RIGHT;
    const link: DatoCmsLink | undefined = links && links.length > 0 ? links[0] : undefined;

    let imageContent: JSX.Element | undefined = undefined;
    if (apiImage && apiImage[0]) {
        imageContent = (
            <ApiImageComponent className='rounded-3xl w-full' apiImage={apiImage[0]} />
        );
        if (showImageAsLink && link) {
            imageContent = (
                <Link
                    className="w-full"
                    internalPageReference={link.internalPageReference}
                    internalPageSectionId={link.internalSectionComponentId}
                    externalPageUrl={link.externalPageUrl}
                    title={link.descriptiveTitle}
                >{imageContent}</Link>);
        }
    }

    const subtitleContent = (subtitle && <label className={`uppercase text-theme-secondary-text font-semibold text-center md:${getTextAlignmentClass(subtitleAlignment)}`}>{subtitle}</label>);

    let titleContent = (title && <h3 className={`text-center md:${getTextAlignmentClass(titleAlignment)}`}>
        { <HtmlEntityTextComponent text={title} /> }
    </h3>);
    if (showTitleAsLink && link) {
        titleContent = (
            <Link
                internalPageReference={link.internalPageReference}
                internalPageSectionId={link.internalSectionComponentId}
                externalPageUrl={link.externalPageUrl}
                title={link.descriptiveTitle}
            >{titleContent}</Link>);
    }

    let itemClass: string = '';
    if (isCenterAligned) {
        itemClass = 'page-list-image-center';
    } else if (isRightAligned) {
        itemClass = 'page-list-image-right';
    } else {
        itemClass = 'page-list-image-left';
    }

    const listItem = (
        <div className={`${itemClass} bg-theme-primary rounded`}>
            <div className="px-4 pt-4">
                {imageContent}

                <div className="page-list-text">
                    { subtitleContent }

                    { titleContent }
                </div>
            </div>
        </div>
    );

    return listItem;
};

export default PageListItemComponent;
